import { PASSWORD_CHECK, checkErrorMinLength, checkErrorMaxLength } from '@chilecompra/react-kit/utils'
import { isValidRut } from './rut-utils'

/**
 * Check if the passwords meet the requirements.
 */
export const checkInputErrorPassword = customMessage => value =>
  PASSWORD_CHECK.test(value) ? '' : customMessage || 'Tu contraseña no cumple con los requisitos mínimos.'

/**
 * Check if the passwords matchs.
 */
export const checkInputErrorSamePasswords = (passwordToCompare, customMessage) => value =>
  value === passwordToCompare ? '' : customMessage || 'Esta contraseña no coincide con la anterior.'

/**
 * Check if the given string value is a National DNI.
 */
export const checkInputNationalDniError = customMessage => value => {
  return isValidRut(value) ? customMessage || 'Has ingresado un RUT chileno' : ''
}

/**
 * Check if the given Input value satisfy the minimum length allowed.
 */
export const checkInputErrorMinLength = (minLength, customMessage) => value => {
  const isString = typeof value === 'string'

  if (checkErrorMinLength(value, minLength)) {
    return ''
  }

  return (
    customMessage ||
    (isString
      ? `Este campo debe tener un mínimo de ${minLength} caracteres.`
      : `Este campo debe tener un mínimo de ${minLength} dígitos.`)
  )
}

/**
 * Check if the given Input value satisfy the maximum length allowed.
 */
export const checkInputErrorMaxLength = (maxLength, customMessage) => value => {
  const isString = typeof value === 'string'

  if (checkErrorMaxLength(value, maxLength)) {
    return ''
  }

  return (
    customMessage ||
    (isString
      ? `Este campo excede el máximo de ${maxLength} caracteres permitido.`
      : `Este campo permite hasta ${maxLength} dígitos.`)
  )
}
